import { useState } from 'preact/compat';
import { useQuery } from '@apollo/client';
import useLocalStorageState from 'use-local-storage-state';

import GET_SPECIALS_LIST from '@/queries/getSpecialsList';

function useSpecials() {
	const [filteredSpecials, setFilteredSpecials] = useState([{
		'menuDisplayConfiguration': {
			'image': '',
		},
	}]);
	const [retailerObject, setRetailerObject] = useLocalStorageState("dutchie_retailer");
	const { loading, error, data } = useQuery(GET_SPECIALS_LIST, {
		variables: {
			retailerId: retailerObject?.id,
		},
		skip: !retailerObject,
		onCompleted: (data) => {
			const today = new Date();
			const dayOfWeek = today.getDay();
			const filtered = data.specials.filter((special) => {
				// is this special configured to show on certain days?
				if ( special?.scheduleConfiguration?.days ) {
					// if it is, does today match one of those days?
					return special?.scheduleConfiguration?.days?.includes(dayOfWeek); 
				}
				return special;
			});
			setFilteredSpecials(filtered);
		}
	});

	return { loading, error, data, filteredSpecials, retailerObject };

}
export default useSpecials;